import { Link } from "react-router-dom";

const offers = [
  {
    icon: "ri-door-open-line",
    title: "Bifold Doors",
    desc: "Open your home to the garden with our stunning aluminium bifold doors. Maximum glass, minimal frames.",
    image: "https://public.readdy.ai/ai/img_res/d75bff62b48bd2b94dba33ca3db323e0.jpg",
    path: "/products",
  },
  {
    icon: "ri-window-line",
    title: "Windows",
    desc: "uPVC and aluminium windows in every style — casement, sash, tilt & turn, and bay — with A-rated energy efficiency.",
    image: "https://readdy.ai/api/search-image?query=modern%20white%20windows%20residential%20home%20exterior%20uPVC%20aluminium%20elegant%20clean%20contemporary%20uk&width=400&height=300&seq=offer2&orientation=landscape",
    path: "/products",
  },
  {
    icon: "ri-home-3-line",
    title: "Composite Doors",
    desc: "Premium composite entrance doors with superb security, thermal performance, and unmatched kerb appeal.",
    image: "https://readdy.ai/api/search-image?query=premium%20composite%20front%20door%20elegant%20uk%20home%20entrance%20anthracite%20modern%20stylish%20residential&width=400&height=300&seq=offer3&orientation=landscape",
    path: "/products",
  },
  {
    icon: "ri-sun-line",
    title: "Conservatories",
    desc: "Extend your living space with a beautifully crafted conservatory — designed for year-round comfort and enjoyment.",
    image: "https://readdy.ai/api/search-image?query=elegant%20white%20conservatory%20garden%20extension%20uk%20home%20bright%20interior%20glass%20roof%20traditional&width=400&height=300&seq=offer4&orientation=landscape",
    path: "/products",
  },
];

export default function WhatWeOffer() {
  return (
    <section className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center max-w-2xl mx-auto mb-16">
          <span
            className="text-amber-600 text-xs font-bold tracking-widest uppercase"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            Our Products
          </span>
          <h2
            className="text-4xl lg:text-5xl font-bold text-zinc-900 mt-3 mb-4"
            style={{ fontFamily: "'Cormorant Garamond', serif" }}
          >
            What We Offer
          </h2>
          <p className="text-zinc-500 text-base leading-relaxed" style={{ fontFamily: "'Raleway', sans-serif" }}>
            From replacement windows to full conservatory builds, Ensure Windows delivers quality craftsmanship across a comprehensive range of home glazing solutions.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
          {offers.map((offer) => (
            <Link
              to={offer.path}
              key={offer.title}
              className="group rounded-lg overflow-hidden border border-stone-100 hover:border-amber-200 transition-all duration-300 cursor-pointer block"
            >
              <div className="w-full h-48 overflow-hidden">
                <img
                  src={offer.image}
                  alt={offer.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-500"
                />
              </div>
              <div className="p-6">
                <div className="w-10 h-10 flex items-center justify-center bg-amber-50 rounded-md mb-4">
                  <i className={`${offer.icon} text-amber-600 text-xl`}></i>
                </div>
                <h3
                  className="text-xl font-bold text-zinc-900 mb-2"
                  style={{ fontFamily: "'Cormorant Garamond', serif" }}
                >
                  {offer.title}
                </h3>
                <p className="text-zinc-500 text-sm leading-relaxed" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  {offer.desc}
                </p>
                <div className="flex items-center gap-1 mt-4 text-amber-600 text-sm font-semibold" style={{ fontFamily: "'Raleway', sans-serif" }}>
                  <span>Learn more</span>
                  <div className="w-4 h-4 flex items-center justify-center">
                    <i className="ri-arrow-right-line text-sm group-hover:translate-x-1 transition-transform"></i>
                  </div>
                </div>
              </div>
            </Link>
          ))}
        </div>

        <div className="text-center mt-12">
          <Link
            to="/products"
            className="inline-flex items-center gap-2 border-2 border-amber-600 text-amber-600 hover:bg-amber-600 hover:text-white font-semibold px-8 py-3 rounded-md transition-all duration-200 whitespace-nowrap cursor-pointer"
            style={{ fontFamily: "'Raleway', sans-serif" }}
          >
            View All Products &amp; Services
            <div className="w-4 h-4 flex items-center justify-center"><i className="ri-arrow-right-line"></i></div>
          </Link>
        </div>
      </div>
    </section>
  );
}
